// export const CONFIG_VARS = Object.freeze({
//   baseUrl:
//     // "https://adminpreprod.inmobiusinfinitylearn.com/api/v1", //preprod
//     "https://admin.inmobiusinfinitylearn.com/api/v1", //prod

//   //S3buket: "/reports",
//   S3buket:
//     // "https://storage.googleapis.com/inmobius-user-assets-preprod/reports", // pre prod
//     "https://storage.googleapis.com/inmobius-user-assets-production/reports", // prod

//   SchoolBuket:
//     // "https://storage.googleapis.com/inmobius-assets-preprod/school-reports", //prepord
//     "https://storage.googleapis.com/inmobius-assets-production/school-reports", //prod
// });

const PREPROD_CONFIG = Object.freeze({
  baseUrl: "https://adminpreprod.inmobiusinfinitylearn.com/api/v1",
  S3buket:
    "https://storage.googleapis.com/inmobius-user-assets-preprod/reports",
  SchoolBuket: "https://storage.googleapis.com/inmobius-assets-preprod/",
});

const PROD_CONFIG = Object.freeze({
  baseUrl: "https://admin.inmobiusinfinitylearn.com/api/v1",
  S3buket:
    "https://storage.googleapis.com/inmobius-user-assets-production/reports",
  SchoolBuket: "https://storage.googleapis.com/inmobius-assets-production/",
});

// Function to determine current environment based on hostname
function getCurrentEnvironment() {


  if (typeof window !== "undefined" && window.location) {
    const hostname = window.location.hostname;

    // Production hostname
    if (hostname === "geniusreports.infinitylearn.com") {
      return "production";
    }

    // Preprod hostnames (including localhost and 127.0.0.1 for development)
    if (
      hostname === "geniusreports.devinfinitylearn.in" ||
      hostname === "localhost" ||
      hostname === "127.0.0.1"
    ) {
      return "preprod";
    }
  }

  // Default fallback to preprod for development/unknown environments
  return "preprod";
}

// Export the appropriate configuration based on current hostname
export const CONFIG_VARS =
  getCurrentEnvironment() === "production" ? PROD_CONFIG : PREPROD_CONFIG;
